module.exports = __webpack_public_path__ + "static/img/search__date__icon.372600f5.svg";